import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhomSection() {
  return <section className="bg-white py-20 px-4 border-t border-soft-gray" data-id="element-97">
      <div className="max-w-5xl mx-auto" data-id="element-98">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-navy text-center mb-16" data-id="element-99">
          Este método es para vos si...
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-100">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-green-50/50 p-8 rounded-2xl border border-green-100" data-id="element-101">
            <h3 className="text-2xl font-bold text-green-800 mb-6 flex items-center gap-2" data-id="element-102">
              PARA QUIÉN SÍ ES
            </h3>
            <ul className="space-y-4" data-id="element-103">
              {['Tenés un bebé de entre 4 y 24 meses', 'Estás agotada de improvisar cada noche', 'Querés entender el problema y no solo aplicar una técnica', 'Buscás un método con presencia parental, no de abandono', 'Estás dispuesta a ser consistente durante al menos 7 noches seguidas', 'Querés que toda la familia duerma mejor sin culpa'].map((item, i) => <li key={i} className="flex items-start gap-3 text-navy/80 font-medium" data-id="element-104">
                  <CheckCircle2 className="text-green-500 flex-shrink-0 mt-1" size={20} data-id="element-105" />
                  <span data-id="element-106">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-50/50 p-8 rounded-2xl border border-red-100" data-id="element-107">
            <h3 className="text-2xl font-bold text-red-800 mb-6 flex items-center gap-2" data-id="element-108">
              PARA QUIÉN NO ES
            </h3>
            <ul className="space-y-4" data-id="element-109">
              {['Si tu bebé tiene menos de 4 meses (el sistema nervioso todavía no está maduro para trabajar el sueño)', 'Si tu bebé tiene una condición médica que afecte el sueño sin diagnóstico previo (consultá primero con tu pediatra)', 'Si buscás resultados sin ningún tipo de proceso ni consistencia'].map((item, i) => <li key={i} className="flex items-start gap-3 text-navy/80 font-medium" data-id="element-110">
                  <XCircle className="text-red-500 flex-shrink-0 mt-1" size={20} data-id="element-111" />
                  <span data-id="element-112">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}